import { Stack, Typography } from '@mui/material';
import { InvoiceHistoryEmptyState } from '@vy/ui-design-system';
import { FC } from 'react';

export const LightInvoiceViewPageActivityEmptyState: FC = () => {
  return (
    <Stack
      direction="column"
      sx={{
        gap: "9x",
        alignItems: "center",
        justifyContent: "center",
        height: "271px"
      }}>
      <div style={{ paddingBottom: '12px' }}>
        <InvoiceHistoryEmptyState />
      </div>
      <Typography
        sx={{
          lineHeight: "20px",
          fontWeight: 600,
          fontSize: 14
        }}>
        No invoice history yet
      </Typography>
      <Typography
        sx={{
          lineHeight: "20px",
          color: "#7E8796",
          fontSize: 14,
          textAlign: "center",
          width: "288px"
        }}>
        Once you start invoicing, your invoice history will appear here.
      </Typography>
    </Stack>
  );
};
